const getCandidateEmailId = (report_url: string): string => {
  const splittedReportUrl = report_url ? report_url.split('/') : '';
  return splittedReportUrl[4];
};

export const getPiiTransferLink = (report_url: string): string => {
  const emailId = getCandidateEmailId(report_url);
  return `${import.meta.env.VITE_CONSENT_FLOW_URL}/pii/${emailId}/ssn`;
};

export const getConsentLink = (report_url: string): string => {
  const emailId = getCandidateEmailId(report_url);
  return `${import.meta.env.VITE_CONSENT_FLOW_URL}/consent/${emailId}`;
};
